import {
  ActionIcon,
  Menu,
  Stack,
  Text,
  ThemeIcon,
  Tooltip
} from '@mantine/core'
import { IconProps, IconThumbUp } from '@tabler/icons-react'
import { ReactElement, ReactNode, cloneElement } from 'react'
import { FormattedMessage } from 'react-intl'
import { getRelativeTimeFromNow } from '@/utils/date'

type NotificationItemProps = {
  message: ReactNode
  icon?: ReactElement<IconProps>
  dateTime: string
  isRead?: boolean
  onMarkAsRead: () => void
  onClick: () => void
}

export const NotificationItem = ({
  message,
  icon,
  dateTime,
  isRead,
  onMarkAsRead,
  onClick
}: NotificationItemProps) => {
  const handleMarkAsRead = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation() // Prevents the menu from closing
    onMarkAsRead()
  }

  return (
    <Menu.Item
      component="a"
      p="md"
      leftSection={
        icon && (
          <ThemeIcon
            variant="light"
            color="brand-primary"
            radius="xl"
            size="lg"
          >
            {cloneElement(icon, {
              style: {
                ...(icon.props.style || {}),
                width: '50%',
                height: '50%'
              }
            })}
          </ThemeIcon>
        )
      }
      rightSection={
        !isRead && (
          <Tooltip label={<FormattedMessage id="notifications.markRead" />}>
            <ActionIcon
              variant="subtle"
              radius="xl"
              size="md"
              onClick={handleMarkAsRead}
            >
              <IconThumbUp style={{ width: '60%', height: '60%' }} />
            </ActionIcon>
          </Tooltip>
        )
      }
      style={{
        opacity: isRead ? 0.5 : 1,
        alignItems: 'flex-start'
      }}
      onClick={onClick}
    >
      <Stack gap={4}>
        <Text size="xs" fw={isRead ? 'normal' : 'bold'}>
          {message}
        </Text>

        <Text size="xs" c="dimmed">
          {getRelativeTimeFromNow(dateTime)}
        </Text>
      </Stack>
    </Menu.Item>
  )
}
